import type { ApiResponse } from "@/types/common";
import { privateRequest, publicRequest } from "../axios";
import type { AxiosResponse } from "axios";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  permissions: string[];
}

interface ForgotPasswordRequest {
  email: string;
}

interface ResetPasswordRequest {
  token: string;
  password: string;
  email: string;
  ResetPasswordMethod: string;
}

const ENDPOINTS = {
  LOGIN: "/auth/login",
  LOGOUT: "/auth/logout",
  FORGOT_PASSWORD: "/auth/forgot-password",
  RESET_PASSWORD: "/auth/reset-password",
};

const login = async (data: LoginRequest) => {
  const response = await publicRequest.post<ApiResponse<LoginResponse>>(ENDPOINTS.LOGIN, data);
  return response?.data;
};

const logout = async (): Promise<{ message: string }> => {
  const response: AxiosResponse<{ message: string }> = await privateRequest.post(
    ENDPOINTS.LOGOUT,
  );
  return response.data;
};

const forgotPassword = async (data: ForgotPasswordRequest): Promise<{ message: string }> => {
  const response: AxiosResponse<{ message: string }> = await publicRequest.post(
    ENDPOINTS.FORGOT_PASSWORD,
    data,
  );
  return response.data;
};

const reset = async (data: ResetPasswordRequest): Promise<{ message: string }> => {
  const response: AxiosResponse<{ message: string }> = await publicRequest.post(
    ENDPOINTS.RESET_PASSWORD,
    data,
  );
  return response.data;
};

const AuthService = {
  login,
  logout,
  forgotPassword,
  reset,
};

export default AuthService;
